import { Module, VuexModule, Mutation, getModule, Action } from 'vuex-module-decorators';
import { Orderbook } from '@/api/bitflyer/Orderbook';
import store from '@/store';
import { OrderbookArray } from '@/types/orderbook';
import { grouping } from '@/utils/grouping';

export interface IBitflyerState {
  rowSize: number;
  factor: number;
  orderbookArray: OrderbookArray;
  ltp: number;
  lastTickDirection: number;
  spread: number;
  bestBid: number;
  bestAsk: number;
  spotLtp: number;
}

@Module({ dynamic: true, store, name: 'bitflyer', namespaced: true })
class Bitflyer extends VuexModule implements IBitflyerState {
  public rowSize = 20;
  public factor = 100;
  public orderbookArray: OrderbookArray = {
    bids: [],
    asks: [],
  };
  public ltp = 0;
  public lastTickDirection = 0;
  public spread = 0;
  public bestBid = 0;
  public bestAsk = 0;
  public spotLtp = 0;

  @Mutation
  public UPDATE_ORDERBOOK(orderbook: Orderbook) {
    const ob = orderbook.getOrderbook()!;
    if (ob) {
      const groupedOb = grouping(ob, this.factor, this.rowSize);
      this.orderbookArray.bids = groupedOb.bids;
      this.orderbookArray.asks = groupedOb.asks;
    }
  }
  @Mutation
  public UPDATE_TICKER({ ltp, best_bid, best_ask}: { ltp: number, best_bid: number, best_ask: number }) {
    if (this.ltp !== 0 && this.ltp !== ltp) {
      this.lastTickDirection = ltp - this.ltp;
    }
    this.ltp = ltp;
    this.spread = best_ask - best_bid;
    this.bestBid = best_bid;
    this.bestAsk = best_ask;
  }
  @Mutation
  public UPDATE_SPOT_TICKER({ ltp }: { ltp: number }) {
    this.spotLtp = ltp;
  }
  @Mutation
  public SET_FACTOR(factor: number ) {
    this.factor = factor;
  }

  @Action({ commit: 'SET_FACTOR' })
  public setFactor(factor: number) {
    return factor;
  }
}

export const BitFlyerModule = getModule(Bitflyer);
